import * as React from 'react';
import { clsx } from 'clsx';

import * as style from './SearchResultItem.css';
import { Image, LinkButton, useDeviceType } from '@cian/ui-kit';
import { SearchResultItemCell } from './parts';

export interface ISearchResultItemProps {
  logoUrl: string;
  builderUrl: string;
  name: string;
  founded?: string;
  totalBuiltCount: string;
  totalBuiltUrl?: string;
  totalBuildingCount: string;
  totalBuildingUrl?: string;
  totalOffersCount: string;
  totalOffersUrl?: string;
}
export const SearchResultItem: React.FC<ISearchResultItemProps> = props => {
  const {
    logoUrl,
    name,
    builderUrl,
    founded,
    totalBuiltUrl,
    totalBuiltCount,
    totalBuildingCount,
    totalBuildingUrl,
    totalOffersCount,
    totalOffersUrl,
  } = props;
  const deviceType = useDeviceType();
  const buttonSize = React.useMemo(() => (deviceType === 'phone' ? 'M' : 'XS'), [deviceType]);

  return (
    <tr className={style['row']} data-testid="SearchResultItem">
      <SearchResultItemCell href={builderUrl} title={name}>
        <Image src={logoUrl} alt={name} objectFit={'cover'} width={'72px'} height={'72px'} />
      </SearchResultItemCell>
      <SearchResultItemCell href={builderUrl} title={name}>
        <span className={clsx(style['cell-title'], style['cell-title--black'])}>{name}</span>
        {founded && <span className={style['cell-text']}>{founded}</span>}
      </SearchResultItemCell>
      <SearchResultItemCell href={totalBuiltUrl} title={`Сдано ${totalBuiltCount}`}>
        <span className={style['cell-title']}>Сдано</span>
        <span className={clsx(style['cell-text'], totalBuiltUrl && style['cell-link'])}>{totalBuiltCount}</span>
      </SearchResultItemCell>
      <SearchResultItemCell href={totalBuildingUrl} title={`Строится ${totalBuildingCount}`}>
        <span className={style['cell-title']}>Строится</span>
        <span className={clsx(style['cell-text'], totalBuildingUrl && style['cell-link'])}>{totalBuildingCount}</span>
      </SearchResultItemCell>
      <SearchResultItemCell>
        <LinkButton size={buttonSize} theme={'fill_secondary'} href={totalOffersUrl || builderUrl}>
          {totalOffersCount}
        </LinkButton>
      </SearchResultItemCell>
    </tr>
  );
};
